module.exports = __webpack_public_path__ + "sidemenu_icon_off.787963b8ae7ca7c63680.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/share/sidemenu_icon_off.svg
// module id = 1016
// module chunks = 0